import React, { Component } from 'react';
import '../App.css';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {isLoggedIn } from '../utils/AuthService';

var DictListwy = React.createClass({

getInitialState: function() {

  return {
    addObject: {
      id: '',
      numerListwy: '',
      cenaZaMb: ''
    },
    data: null,
    selectedListwaId: null
  }
  },

  onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedListwaId: row.id });
		}else {
			this.setState({ selectedListwaId: null });
		}
	},

  onDeleteBtnClicked: function() {
    axios.delete('http://217.182.200.222:8080/dictListwy/' + this.state.selectedListwaId)
      .then(function (response) {
        this.refreshTable();
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },

  refreshTable: function() {
    axios.get('http://217.182.200.222:8080/dictListwy')
    .then(function (dictListwy) {
      this.setState({data: dictListwy.data});
    }.bind(this));
  },

  getListwyById: function(id) {
    for(var i in this.state.data) {
      if(this.state.data[i].id === id) {
        return this.state.data[i];
      }
    }
    return '';
  },

  render: function() {
    var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

    if(!isLoggedIn()){
			return (<div></div>);
		};

  return (
    <div>

	<div className="form-group">

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="numerListwy">Numer Listwy: </label>
					</div>
					<div className="col-sm-8">
            <FormControl
              type="text"
              placeholder="Numer Listwy"
              value={this.state.addObject.numerListwy}
              onChange={this.onAddDictListwaNumerChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8">
      </div>
		</div>
		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="cenaZaMb">Cena za mb: </label>
					</div>
					<div className="col-sm-8">
          <FormControl
            type="text"
            placeholder="Cena za MB"
            value={this.state.addObject.cenaZaMb}
            onChange={this.onAddDictListwaCenaZaMBChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8"/>
		</div>

	</div>

  <div>
  <Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj Listwę</Button>
  </div>
    <br/>
  <BootstrapTable data={this.state.data}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          selectRow={selectRowProp}>
    <TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="numerListwy" dataSort={true}>Numer Listwy</TableHeaderColumn>
    <TableHeaderColumn dataField="cenaZaMb">Cena za MB</TableHeaderColumn>
  </BootstrapTable>

<br/>
<div>
<Button bsStyle="danger" onClick={this.onDeleteBtnClicked}>Usuń Listwę</Button>
</div>

</div>
);
},

componentDidMount: function() {
  this.refreshTable();
},

clearAddObject: function() {
  this.state.addObject.id = null;
  this.state.addObject.numerListwy = '';
  this.state.addObject.cenaZaMb = '';
},

onAddDictListwaNumerChange: function(event) {
  this.state.addObject.numerListwy = event.target.value;
  this.forceUpdate();
},

onAddDictListwaCenaZaMBChange: function(event) {
  this.state.addObject.cenaZaMb = event.target.value.replace(/,/g, '.');
  this.forceUpdate();
},

onAddBtnClicked: function() {
  axios.post('http://217.182.200.222:8080/dictListwy/', this.state.addObject)
    .then(function (response) {
      this.refreshTable();
    }.bind(this))
    .catch(function (error) {
      alert("Błędnie wprowadzone dane");
      console.log(error);
    });

    this.setState({
      addObject: {
        id: '',
        numerListwy: '',
        cenaZaMb: ''
      }
    });
}
});

export default DictListwy;



// WEBPACK FOOTER //
// ./src/components/DictListwy.js